import { reviewState } from './review.state';
import { reviewActions } from './review.action';
import { reviewMutations } from './review.mutation';

export default {
  namespaced: true,
  state: reviewState,
  getters: {},
  actions: reviewActions,
  mutations: reviewMutations,
};
